import { getObjectFromLocalStorage, setObjectInLocalStorage } from "@/common/helpers/localStorage";

export const getLastOrganizationId = (): string | undefined => {
  return getObjectFromLocalStorage?.<{ organizationId: string }>("lastOrganizationId")?.organizationId;
};

export const setLastOrganizationId = (organizationId: string) => {
  setObjectInLocalStorage?.("lastOrganizationId", { organizationId });
};
